import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { FacilitiesMapPanel } from "../components/FacilitiesMapPanel";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import {
  enterpriseOverviewQueryOptions,
  useGetEnterpriseOverview,
} from "../queries/useGetEnterpriseOverview";

function MapRouteComponent() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();
  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        title={t("enterprise.common.selectCustomerTitle")}
        description={t("enterprise.facilitiesMap.customerSelectionDescription")}
      />
    );
  }

  return <MapRouteContent externalCustomerId={externalCustomerId} />;
}

function MapRouteContent({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data } = useGetEnterpriseOverview(customer.customerId);

  return (
    <FacilitiesMapPanel
      facilities={data.facilities}
      customerName={data.customer.customerName}
      isLoading={false}
      error={null}
    />
  );
}

export const Route = createFileRoute("/_app/map")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }
    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );
    return context.queryClient.ensureQueryData(
      enterpriseOverviewQueryOptions(customer.customerId),
    );
  },
  component: MapRouteComponent,
});
